"use client";

import React from "react";
import { SortOption } from "@/lib/utils/common";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useTranslations } from "next-intl";
import { usePathname, useRouter } from "@/i18n/routing";
import { useSearchParams } from "next/navigation";

type Props = {
  options: Array<SortOption>;
  current: SortOption;
};

const BasicSort: React.FC<Props> = ({ current, options }) => {
  const t = useTranslations("sort");
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  return (
    <Select
      value={current}
      onValueChange={(next: string) => {
        const newParams = new URLSearchParams(searchParams.toString());

        if (!next) {
          newParams.delete("sort");
        } else {
          newParams.set("sort", next);
        }

        const query = newParams.toString();
        const href = query ? `${pathname}?${query}` : pathname;

        router.replace(href);
      }}
    >
      <SelectTrigger aria-label={t("sort")} className="w-fit min-w-24 font-medium text-sm">
        <div className="flex flex-row items-center gap-2 pr-2">
          <SelectValue placeholder={t("sort")} />
        </div>
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {options.map((option) => (
            <SelectItem key={option} value={option}>
              {t(`options.${option}`)}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};

export default BasicSort;
